import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[existingDataDuplicateValueValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ExistingDataDuplicateValueValidatorDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class ExistingDataDuplicateValueValidatorDirective implements Validator {
	@Input() existingDataDuplicateValueValidator: string[] | (() => string[]) = [];

	validate(control: AbstractControl): { [key: string]: any } | null {
		const existingData =
			typeof this.existingDataDuplicateValueValidator === 'function'
				? this.existingDataDuplicateValueValidator()
				: this.existingDataDuplicateValueValidator;
		if (
			control.value &&
			existingData.some(
				(item) => item?.toString().trim().localeCompare(control.value.toString().trim(), undefined, { sensitivity: 'accent' }) === 0
			)
		) {
			return { duplicateValue: true };
		}
		return null; //Validation passed
	}
}
